import { CENARIOS_DIDATICOS, type CenarioDidatico } from '../../dominio/tabletop/cenariosDidaticos'
import { IconeFechar } from '../icones'

interface Props {
  readonly mesaCompartilhada?: boolean
  readonly aberto: boolean
  readonly cenarioAtualId: string
  readonly aoSelecionarCenario: (idCenario: string) => void
  readonly aoFechar: () => void
}

export function SeletorCenarioModal({
  aberto,
  mesaCompartilhada = false,
  cenarioAtualId,
  aoSelecionarCenario,
  aoFechar,
}: Props) {
  if (!aberto) return null

  return (
    <div className="modal-cenarios-overlay" role="dialog" aria-modal="true" aria-labelledby="titulo-modal-cenarios">
      <div className="modal-cenarios-container">
        <div className="modal-cenarios-cabecalho">
          <div>
            <h2 id="titulo-modal-cenarios" className="modal-cenarios-titulo">
              Cenários Operacionais
            </h2>
            <p className="modal-cenarios-subtitulo">
              {mesaCompartilhada ? 'Escolha um exemplo, ajuste os elementos e explore a ocorrência com sua equipe.' : 'Selecione um cenário para simular o atendimento em 6 etapas do protocolo tático de salvamento veicular.'}
            </p>
          </div>
          <button
            type="button"
            className="btn-acao-cad btn-acao-cad--secundario"
            onClick={aoFechar}
            aria-label="Fechar janela"
            title="Fechar"
          >
            <IconeFechar />
          </button>
        </div>

        <div className="modal-cenarios-grade">
          {CENARIOS_DIDATICOS.map((cenario: CenarioDidatico) => {
            const ehAtual = cenario.id === cenarioAtualId

            return (
              <div
                key={cenario.id}
                className={`card-cenario-didatico ${ehAtual ? 'card-cenario-didatico--ativo' : ''}`}
              >
                <div className="card-cenario-didatico__topo">
                  <span className="card-cenario-didatico__badge">{cenario.badge}</span>
                  {ehAtual && <span className="card-cenario-didatico__badge-ativo">Cenário Ativo</span>}
                </div>

                <h3 className="card-cenario-didatico__titulo">{cenario.titulo}</h3>
                <span className="card-cenario-didatico__subtitulo">{cenario.subtitulo}</span>

                <p className="card-cenario-didatico__descricao">{cenario.descricao}</p>

                <div className="card-cenario-didatico__objetivo">
                  <strong>Objetivo Operacional:</strong> {cenario.objetivoOperacional ?? cenario.objetivoAula}
                </div>

                <div className="card-cenario-didatico__vitimas">
                  <strong>Vítimas:</strong>
                  <ul>
                    {cenario.vitimas.map((v) => (
                      <li key={v.id}>
                        <span className={`badge-triagem-ponto badge-triagem-ponto--${v.triagemReferencia}`} />
                        <strong>{v.nomeCurto}</strong> ({v.papel}) — Prioridade: {v.triagemReferencia.toUpperCase()}
                      </li>
                    ))}
                  </ul>
                </div>

                <button
                  type="button"
                  className={`btn-acao-cad ${ehAtual ? 'btn-acao-cad--secundario' : 'btn-acao-cad--destaque'}`}
                  style={{ marginTop: 'auto', width: '100%', justifyContent: 'center' }}
                  onClick={() => {
                    aoSelecionarCenario(cenario.id)
                    aoFechar()
                  }}
                >
                  {ehAtual ? 'Reiniciar Este Cenário' : 'Carregar Cenário Operacional'}
                </button>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

